import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthLoginService} from '../auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CPATTERN} from '../../shared/helpers/app.constants';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  cvalidate = CPATTERN;
  loading: boolean = false;
  submitted: boolean = false;

  form: FormGroup;
  newPassword: AbstractControl;
  confirmPassword: AbstractControl;
  token: AbstractControl;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private service: AuthLoginService,
              private formBuilder: FormBuilder,
              private ref: ChangeDetectorRef) {
    this.createForm();
  }

  createForm() {
    this.form = this.formBuilder.group({
      newPassword: new FormControl('', Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(100), Validators.pattern(this.cvalidate.PASSWORD)])),
      confirmPassword: new FormControl(''),
      token: new FormControl()
    }, {validator: this.checkIfMatchingPasswords('newPassword', 'confirmPassword')});
    this.newPassword = this.form.controls['newPassword'];
    this.confirmPassword = this.form.controls['confirmPassword'];
    this.token = this.form.controls['token'];
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.token.setValue(params['token']);
    });
  }

  ngOnDestroy() {
    this.ref.detach();
  }

  checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      const passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({notEquivalent: true});
      } else {
        return passwordConfirmationInput.setErrors(null);
      }
    };
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      this.submitted = true;
      this.ref.detectChanges();
      const obj = {
        newPassword: this.newPassword.value,
        token: this.token.value
      };
      this.service.changePassword(obj, () => {
        this.loading = false;
        this.submitted = false;
        this.ref.detectChanges();
      })
        .subscribe(
          (response) => {
            this.router.navigate(['auth/login']);
          }
        );
    }
  }
}
